import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { fetchAuthSession } from 'aws-amplify/auth';

const APPSYNC_URL =
  window.KOREADER_TTS_CONFIG?.APPSYNC_URL ||
  process.env.REACT_APP_APPSYNC_URL ||
  '';

const httpLink = new HttpLink({
  uri: APPSYNC_URL,
  fetch: async (uri, options) => {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();

    return fetch(uri, {
      ...options,
      headers: {
        ...options?.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  },
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

export default client;

export const ON_NEW_AUDIO_SUBSCRIPTION = `
  subscription OnNewAudio($sessionId: String!) {
    onNewAudio(sessionId: $sessionId) {
      sessionId
      audioUrl
      timestamp
      textPreview
      bookTitle
      currentPage
      totalPages
      voiceId
      engine
      language
      error
      errorMessage
    }
  }
`;
